import { Logo } from '@practium/ui';
import { Close } from '@mui/icons-material';
import styles from './ModalHeader.module.css';

interface ModalHeaderProps {
	onClose: () => void;
	isEditMode?: boolean;
}

export const ModalHeader = ({ onClose, isEditMode = false }: ModalHeaderProps) => (
	<div className={styles.header}>
		<div className={styles.left}>
			<Logo className={styles.logo} />
			<div className={styles.divider} />
			<span className={styles.title}>{isEditMode ? 'Editar Região' : 'Criar Nova Região'}</span>
		</div>
		<button className={styles.closeBtn} onClick={onClose} aria-label="Fechar modal">
			<Close sx={{ fontSize: '1.25rem' }} />
		</button>
	</div>
);
